import { useState } from "react";

import { CloseIcon, ReplayIcon } from "@dotnet/telematics-design-system";

import { ApiResources } from "../../../../../api/resources";
import {
  USERS_INVITATIONS_DIALOGS,
  UsersInvitationsDataDto
} from "../../../../../Pages/Users/UsersInvitations/types";
import { useReleaseFeatureToggle } from "../../../../../shared/featureToggles/hooks";
import { FEATURE_NAMES } from "../../../../../shared/featureToggles/types";

const useUsersInvitationsActions = () => {
  const { isReleaseFeatureEnabled } = useReleaseFeatureToggle();

  const initialActionDialogOpenState = {
    [USERS_INVITATIONS_DIALOGS.CancelInvitation]: false,
    [USERS_INVITATIONS_DIALOGS.ResendInvitation]: false
  };

  const [userEmail, setUserEmail] = useState("");
  const [isActionDialogOpen, setIsActionDialogOpen] = useState(
    initialActionDialogOpenState
  );

  const userInvitationActions = [
    {
      title: "resend-invitation",
      open: isActionDialogOpen[USERS_INVITATIONS_DIALOGS.ResendInvitation],
      dialogAction: USERS_INVITATIONS_DIALOGS.ResendInvitation,
      resource: ApiResources.UsersInvitationsResend
    },
    {
      title: "cancel-invitation",
      open: isActionDialogOpen[USERS_INVITATIONS_DIALOGS.CancelInvitation],
      dialogAction: USERS_INVITATIONS_DIALOGS.CancelInvitation,
      resource: ApiResources.UsersInvitationsCancel
    }
  ];

  const handleOpenDialog = (
    data: UsersInvitationsDataDto,
    dialogName: USERS_INVITATIONS_DIALOGS
  ) => {
    setUserEmail(data.email);

    setIsActionDialogOpen({
      ...isActionDialogOpen,
      [dialogName]: true
    });
  };

  const handleCloseDialog = () => {
    setIsActionDialogOpen(initialActionDialogOpenState);
  };

  const actionTitles = [
    USERS_INVITATIONS_DIALOGS.CancelInvitation,
    USERS_INVITATIONS_DIALOGS.ResendInvitation
  ];

  const inlineActions = [
    {
      title: actionTitles[0],
      icon: <CloseIcon />,
      clickAction: (data: UsersInvitationsDataDto) =>
        handleOpenDialog(data, actionTitles[0]),
      renderConditions: () =>
        isReleaseFeatureEnabled(FEATURE_NAMES.CancelInvitation)
    },
    {
      title: actionTitles[1],
      icon: <ReplayIcon />,
      clickAction: (data: UsersInvitationsDataDto) =>
        handleOpenDialog(data, actionTitles[1]),
      renderConditions: () =>
        isReleaseFeatureEnabled(FEATURE_NAMES.ResendInvitation)
    }
  ];

  return {
    userInvitationActions,
    userEmail,
    inlineActions,
    handleCloseDialog
  };
};

export default useUsersInvitationsActions;
